<template>
    <div>
        <el-form-item label="Tytuł"
                      :error="errors[addLanguageSuffix('label')]">
            <el-input v-model="item[addLanguageSuffix('label')]"/>
        </el-form-item>
        <link-component v-model="item.link"
                        :key="`submenu_link_${itemKey}`"
                        :errors="errors['link']"/>
    </div>
</template>
<script>
    export default {
        props: ["item", "errors", "itemKey"]
    }
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// SubmenuItem.vue?ea150650